import { Controller, useFormContext } from "react-hook-form";
import { Picker, View } from "react-native-ui-lib";
import { useTranslation } from "../../../../../../utilities/i18n";
import { PaymentMethodFormValues } from "../../types";
import { Label } from "@towersystems/roam-common-native";

export interface RoundingFieldSetProps {}

const cashRoundingOptions = [
  { label: "Round to 0.05", value: "ROUND_TO_05" },
  { label: "Round to 0.10", value: "ROUND_TO_10" },
  // Add other options here if needed
];

const roundingAlgorithmOptions = [
  { label: "Midpoint Down", value: "ROUND_MIDPOINT_DOWN" },
  { label: "Midpoint Up", value: "ROUND_MIDPOINT_UP" },
  // Add other options here if needed
];

export const RoundingFieldSet = (props: RoundingFieldSetProps) => {
  const { t } = useTranslation("settings");
  const { control } = useFormContext<PaymentMethodFormValues>();

  return (
    <View>
      <Label required label={t("form.cash_rounding.label")} />
      <Controller
        name="rounding.cashRounding"
        control={control}
        render={({
          field: { onChange, value, onBlur },
          fieldState: { error },
        }) => (
          <Picker
            placeholder={t("form.cash_rounding.placeholder")}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            options={cashRoundingOptions}
            validationMessage={error?.message}
          />
        )}
      />
      <Label required label={t("form.cash_rounding_algorithm.label")} />
      <Controller
        name="rounding.roundingAlgorithm"
        control={control}
        render={({
          field: { onChange, value, onBlur },
          fieldState: { error },
        }) => (
          <Picker
            placeholder={t("form.cash_rounding_algorithm.placeholder")}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            options={roundingAlgorithmOptions}
            validationMessage={error?.message}
          />
        )}
      />
    </View>
  );
};
